import AnswerBiasLink from './AnswerBiasLink';

export default AnswerBiasLink;
